// Agente IA — botones del staff en el panel del ticket (aprobar, retirar la
// aprobación, reintentar). La disponibilidad sale de getAiAgentPanelActions;
// las confirmaciones y las llamadas al API las hace la sección que lo usa.
import { useTranslation } from "react-i18next";
import type { Ticket } from "../services/serviceDeskService";
import { getAiAgentPanelActions } from "../services/aiAgentActions";

interface Props {
  ticket: Pick<Ticket, "status" | "aiAgent">;
  isDarkMode: boolean;
  primaryColor: string;
  onApprove: () => void;
  /** `running`: el agente tiene el ticket tomado (la corrida se detendrá). */
  onRevoke: (running: boolean) => void;
  onRetry: () => void;
  now?: number;
}

export function AiAgentActions({ ticket, isDarkMode, primaryColor, onApprove, onRevoke, onRetry, now }: Props) {
  const { t } = useTranslation("serviceDesk");
  const actions = getAiAgentPanelActions(ticket, now);
  const secondary = `rounded-lg border px-4 py-2 text-sm font-semibold ${
    isDarkMode ? "border-gray-600 text-gray-200 hover:bg-gray-700" : "border-gray-300 text-gray-700 hover:bg-gray-50"
  }`;
  const muted = isDarkMode ? "text-gray-400" : "text-gray-500";

  return (
    <>
      {actions.canApprove && (
        <button
          type="button"
          onClick={onApprove}
          className="rounded-lg px-4 py-2 text-sm font-semibold text-white"
          style={{ backgroundColor: primaryColor }}
        >
          {t("ticketDetail.aiAgent.approve")}
        </button>
      )}
      {actions.canRevoke && (
        <button
          type="button"
          onClick={() => onRevoke(actions.leaseLive)}
          className={`rounded-lg border px-4 py-2 text-sm font-semibold ${
            actions.leaseLive
              ? "border-red-300 text-red-600 hover:bg-red-50 dark:hover:bg-red-500/10"
              : secondary
          }`}
        >
          {t(actions.leaseLive ? "ticketDetail.aiAgent.revokeRunning" : "ticketDetail.aiAgent.revoke")}
        </button>
      )}
      {actions.canRetry && (
        <button type="button" onClick={onRetry} className={secondary}>
          {t("ticketDetail.aiAgent.retry")}
        </button>
      )}
      {actions.retryWaitsForLease && (
        <p className={`text-[11px] ${muted}`}>{t("ticketDetail.aiAgent.retryWaitsForLease")}</p>
      )}
      {actions.isClosed && ticket.aiAgent && ticket.aiAgent.state !== "idle" && (
        <p className={`text-[11px] ${muted}`}>{t("ticketDetail.aiAgent.closedNoActions")}</p>
      )}
    </>
  );
}
